import "./modules/core-js";
import { emailCaptureService } from './modules/email-capture-service';
import { onReady } from "./modules/window-service";

onReady(() => { emailCaptureService.setupForms(); });